/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Estes_Pickups_SelectedInputs */

const en_orders_no_estes_pickups_selected = /** @type {(inputs: Orders_No_Estes_Pickups_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ESTES pickups selected`)
};

const es_orders_no_estes_pickups_selected = /** @type {(inputs: Orders_No_Estes_Pickups_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay recolecciones ESTES seleccionadas`)
};

/**
* | output |
* | --- |
* | "No ESTES pickups selected" |
*
* @param {Orders_No_Estes_Pickups_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_estes_pickups_selected = /** @type {((inputs?: Orders_No_Estes_Pickups_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Estes_Pickups_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_estes_pickups_selected(inputs)
	return es_orders_no_estes_pickups_selected(inputs)
});